
export class ParentAsset {
  assetId?: number;
  assetName?: string;
  placeholderAsset?: undefined | boolean;
}
